<template>
  <div class="lzMain">
    <h3>凭码自助领证</h3>
    <div class="codebox"><div ref="qrCodeDiv">code</div></div>
  </div>
</template>
<script>
import api from '@/api/index.ts'
import QRCode from 'qrcodejs2';
export default {
  name: 'lzcode',
  data () {
    return {
      codeTxt: ''
    }
  },
  created() {
    this.getlicensecode()
  },
  methods:{
    getlicensecode() {
      api.getlicensecode({}).then(res => {
        if(res.status === 200) {
          this.codeTxt = res.data
          this.$refs.qrCodeDiv.innerHTML = '';
          // 生成卡号二维码
          let PsnQRCode = new QRCode(this.$refs.qrCodeDiv, {
            width: 166,
            height: 166,
            colorDark: 'black',
            colorLight: '#ffffff',
            text: this.codeTxt
          })
          // console.log(PsnQRCode)
        }
      })
    }
  }
}
</script>
<style>
.lzMain{
  text-align: center;
}
.codebox{
  display: inline-block;
}
.lzMain h3{
  padding-top: 50px;
  padding-bottom: 20px;
}
</style>


